/**
 * Métadonnées canoniques pour scoring / API (metadata.Domain, metadata.Task Mongo).
 */
export function getQcmCanonicalMetadata(currentQCM) {
    if (!currentQCM) {
        return { domain: '', task: '', topic: '', keywords: [] };
    }
    const md = currentQCM.metadata || {};
    const domain = String(
        currentQCM.domain || currentQCM.theme || md.Domain || md.domain || ''
    ).trim();
    const task = String(
        currentQCM.task ||
            md.Task ||
            md.task ||
            md.Sub_domain ||
            md.sub_domain ||
            currentQCM.sub_domain ||
            ''
    ).trim();
    const topic = String(currentQCM.topic || md.Topic || md.topic || '').trim();
    const rawKw = currentQCM.keywords || currentQCM.qcm?.keywords || md.keywords || [];
    const keywords = Array.isArray(rawKw)
        ? rawKw
        : typeof rawKw === 'string' && rawKw.trim()
          ? [rawKw]
          : [];
    return { domain, task, topic, keywords };
}
